module.exports = __webpack_public_path__ + "img/versapay-overview-1.46af4ddf.png";